
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Navbar, Nav, Dropdown, Form, Button, Modal, Table } from 'react-bootstrap';
import { Pie } from 'react-chartjs-2'; // Import the Pie chart component
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import styles
import { FaEdit, FaTrash, FaAngleRight, FaAngleLeft, FaAngleUp, FaAngleDown } from 'react-icons/fa';
import generateQuotationPDF from './GenerateQuote'
import Cookies from 'universal-cookie';

ChartJS.register(ArcElement, Tooltip, Legend); // Register necessary components for Chart.js

function QuotationDetail() {
    const cookies = new Cookies();
    const token = cookies.get('token');
    const navigate = useNavigate();
    const currentDate = new Date();

    // Format the date as needed (e.g., "YYYY-MM-DD" or "MM/DD/YYYY")
    const formattedDate = currentDate.toLocaleDateString();
    const parseCurrency = (value) => {
        // Ensure the value is treated as a string before calling replace
        const stringValue = String(value || "0");

        // Remove the "R" symbol and trim any whitespace, then convert to a float
        return parseFloat(stringValue.replace("R", "").trim());
    };

    const { id, dateCreated, Qid } = useParams();
    const [Quotation, setQuotation] = useState(null);
    const [items, setItems] = useState([]);
    // const [hourlyRates, setHourlyRates] = useState(1);
    const [selectedItem, setSelectedItem] = useState({
        PriceListItemID: null, // Matches the auto-incrementing primary key
        ItemName: '', // varchar(100)
        Price: '', // varchar(100)
        CustomerCareTypeID: null, // int, foreign key reference
        GeneralCategory: '', // varchar(50)
        Frequency: '', // varchar(50)
        SN_HoursDay: '', // varchar(50)
        SN_HoursNight: 0.0, // decimal(5,2)
        ENA_HoursDay: '', // varchar(50)
        ENA_HoursNight: 0.0, // decimal(5,2)
        CW_HoursDay: '', // varchar(50)
        CW_HoursNight: 0.0, // decimal(5,2)
        Catering: '', // varchar(50)
        Cleaning: '', // varchar(50)
        Laundry: '', // varchar(50)
        Other: '', // varchar(50)
        DateFrom: '', // date
        DateTo: '', // date
    });

    const [lineItems, setLineItems] = useState([]);
    const [noItems, setNoItems] = useState(false);

    const [TotalsCarePlan, setTotalsCarePlan] = useState({
        SN_HoursDay: 0,
        SN_HoursNight: 0,
        ENA_HoursDay: 0,
        ENA_HoursNight: 0,
        CW_HoursDay: 0,
        CW_HoursNight: 0,
    });

    const [totals, setTotals] = useState({
        Price: 0,
        SN_HoursDay: 0,
        SN_HoursNight: 0,
        ENA_HoursDay: 0,
        ENA_HoursNight: 0,
        CW_HoursDay: 0,
        CW_HoursNight: 0,
        Catering: 0,
        Cleaning: 0,
        Labour: 0,
        Laundry: 0,
        Other: 0,
    });
    const [benefitsTotals, setbenefitsTotals] = useState({
        BenefitBody: 0,
        BenefitMind: 0,
        BenefitSocial: 0
    });
    const [carePlanID, setCarePlanID] = useState(0);
    const [CustomerName, setCustomerName] = useState('');
    const [CustomerDiscount, setCustomerDiscount] = useState('');
    const [headerColor, setHeaderColor] = useState('#ff0000');
    const [fontColor, setFontColor] = useState('light');
    const [logoUrl, setLogoUrl] = useState('');
    const [activities, setActivities] = useState([]);
    const [collapsed, setCollapsed] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [isSticky, setIsSticky] = useState(false);
    const [isSaved, setIsSaved] = useState(true);
    const [temp, setTemp] = useState(false);



    useEffect(() => {
        console.log("Component mounted"); // This should log when the component loads

        const handleScroll = () => {
            console.log("Scrolled"); // Check if event listener is firing
            const scrollPosition = window.scrollY;
            console.log("Scroll Position:", scrollPosition);
            const threshold = 700;
            setIsSticky(scrollPosition > threshold);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            console.log("Cleanup running"); // Check if cleanup runs
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const setSelectedCustomerData = () => {
        if (!Quotation) return;

        const customerData = {
            CustomerName: CustomerName || "Unknown",
            ReportDate: new Date().toLocaleDateString(),
            TotalMonthlyFee: total.toFixed(2),
            CustomerDiscount: CustomerDiscount || 0,
            FinalQuotedPrice: (total - ((total * CustomerDiscount) / 100)).toFixed(2),
            CarePlanActivities: activities.length > 0 ? activities : ["No Care Plan activities found"],
            QuotedServices: lineItems.map(item => ({
                name: item.ItemName,
                fee: parseCurrency(item.Price)
            })),
            AdditionalNotes: notes
        };

        return customerData;
    };

    const handleCreateQuotepdf = async () => {
        const quotationData = setSelectedCustomerData();

        if (!quotationData) {
            alert("Quotation data is not available.");
            return;
        }

        // Store pie charts as references
        const pieCharts = [
            document.querySelector('.chart-container .chart-item:nth-child(1) canvas'),
            document.querySelector('.chart-container .chart-item:nth-child(2) canvas'),
            document.querySelector('.chart-container-two .chart-item:nth-child(1) canvas'),
            document.querySelector('.chart-container-two .chart-item:nth-child(2) canvas'),
            document.querySelector('.chart-container-three .chart-item:nth-child(1) canvas'),
        ].filter(chart => chart);
        console.log(pieCharts, 'pieCharts')
        console.log(quotationData, 'quotationData')
        generateQuotationPDF(quotationData, pieCharts);
    };

    useEffect(() => {
        const loadSettings = async () => {
            try {
                const response = await fetch('https://api.cpq.yourcrm.co.za/api/get_settings', {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    console.error(`HTTP error! Status: ${response.status}`);
                    alert(`Failed to fetch settings: ${response.statusText}`);
                    return;
                }

                const settings = await response.json(); // Parse the JSON data
                console.log(settings)
                settings.forEach(setting => {
                    if (setting.SettingName === 'headerColor') setHeaderColor(setting.SettingValue);
                    if (setting.SettingName === 'fontColor') setFontColor(setting.SettingValue);
                    if (setting.SettingName === 'logoUrl') setLogoUrl(setting.SettingValue);
                });


            } catch (error) {
                console.error('Error fetching data:', error);
                alert('An error occurred while fetching settings data. Please try again later.');
            }
        };

        // Call the loadSettings function
        loadSettings();
    }, []);
    const handleSort = (key, isNumeric = false) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        const sortedData = [...lineItems].sort((a, b) => {
            if (isNumeric) {
                return direction === 'ascending'
                    ? (a[key] || 0) - (b[key] || 0)
                    : (b[key] || 0) - (a[key] || 0);
            } else {
                return direction === 'ascending'
                    ? (a[key] || '').toString().localeCompare((b[key] || '').toString())
                    : (b[key] || '').toString().localeCompare((a[key] || '').toString());
            }
        });

        setSortConfig({ key, direction });
        setLineItems(sortedData);
    };

    const getSortIndicator = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? <FaAngleUp /> : <FaAngleDown />;
        }
        return null;
    };

    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
    };

    const filteredItems = lineItems.filter(item =>
        item.ItemName.toLowerCase().includes(searchTerm) ||
        item.Description.toLowerCase().includes(searchTerm)
    );
    const [hourlyRates, setHourlyRates] = useState({ SN: 0, ENA: 0, CW: 0 });

    const fetchHourlyRates = async (dateCreated) => {
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/staff/rates?dateCreated=${dateCreated}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // Check if the response is JSON
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                throw new Error("Received non-JSON response");
            }

            const ratesArray = await response.json();

            // Convert the array to an object with SN, ENA, CW keys
            const mappedRates = ratesArray.reduce((acc, rate) => {
                const { StaffType, StandardHourlyPrice } = rate;
                acc[StaffType] = parseFloat(StandardHourlyPrice) || 0;
                return acc;
            }, { SN: 0, ENA: 0, CW: 0 });

            setHourlyRates(mappedRates);
        } catch (error) {
            console.error('Error fetching hourly rates:', error);
        }
    };



    useEffect(() => {
        fetchHourlyRates(dateCreated);
    }, []); // Empty array means this effect runs once when the component mounts
    const calculateTotals = (items, rates) => {
        return items.reduce((totals, item) => {
            const multiplier = parseFloat(item.Multiplier) || 1;
            const totalSN = (totals.SN_HoursDay + totals.SN_HoursNight) * rates.SN;
            const totalENA = (totals.ENA_HoursDay + totals.ENA_HoursNight) * rates.ENA;
            const totalCW = (totals.CW_HoursDay + totals.CW_HoursNight) * rates.CW;
            const totalLabourCost = totalSN + totalENA + totalCW;

            return {
                Price: totals.Price + (parseFloat(parseCurrency(item.Price) || 0)),
                SN_HoursDay: totals.SN_HoursDay + (parseFloat(item.SN_HoursDay || 0) * multiplier),
                SN_HoursNight: totals.SN_HoursNight + (parseFloat(item.SN_HoursNight || 0) * multiplier),
                ENA_HoursDay: totals.ENA_HoursDay + (parseFloat(item.ENA_HoursDay || 0) * multiplier),
                ENA_HoursNight: totals.ENA_HoursNight + (parseFloat(item.ENA_HoursNight || 0) * multiplier),
                CW_HoursDay: totals.CW_HoursDay + (parseFloat(item.CW_HoursDay || 0) * multiplier),
                CW_HoursNight: totals.CW_HoursNight + (parseFloat(item.CW_HoursNight || 0) * multiplier),
                Catering: totals.Catering + parseFloat(parseCurrency(item.Catering) || 0),
                Cleaning: totals.Cleaning + parseFloat(parseCurrency(item.Cleaning) || 0),
                Laundry: totals.Laundry + parseFloat(parseCurrency(item.Laundry) || 0),
                Other: totals.Other + parseFloat(parseCurrency(item.Other) || 0),
                Labour: totalLabourCost, // Add the total labour cost
            };
        }, {
            SN_HoursDay: 0,
            SN_HoursNight: 0,
            ENA_HoursDay: 0,
            ENA_HoursNight: 0,
            CW_HoursDay: 0,
            CW_HoursNight: 0,
            Catering: 0,
            Cleaning: 0,
            Laundry: 0,
            Other: 0,
            Labour: 0,
        });
    };


    useEffect(() => {
        const fetchQuotation = async () => {
            try {
                const response = await fetch(`https://api.cpq.yourcrm.co.za/api/quotation/${id}/${dateCreated}/${Qid}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        }
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    console.log(data, 'data')
                    setQuotation(data.Quotation);
                    setLineItems(data.lineItems);
                    setTemp(data.lineItems)
                    const calculatedTotals = calculateTotals(data.lineItems, hourlyRates);
                    setTotals(calculatedTotals);

                } else if (response.status === 404) {
                    console.error('Failed to fetch quotation');

                } else {
                    console.error('Failed to fetch quotation');
                }
            } catch (error) {
                console.error('An error occurred while fetching the Quotation:', error);
            }
        };



        const fetchItems = async () => {
            try {
                const response = await fetch(`https://api.cpq.yourcrm.co.za/api/pricelistItems`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });
                const data = await response.json();
                if (Array.isArray(data)) {
                    const sortedData = data.sort((a, b) =>
                        a.ItemName.localeCompare(b.ItemName)
                    );
                    setItems(sortedData); // Ensure data is an array before setting it
                } else {
                    console.error('Unexpected data format for Items:', data);
                    setItems([]); // Default to an empty array if the data is not as expected
                }
                if (data.length === 0) {
                    setNoItems(true);
                }
            } catch (error) {
                console.error('Failed to fetch Items:', error);
                setItems([]); // Set an empty array in case of error
            }
        };


        fetchQuotation();
        fetchItems();
        // fetchActivities();


    }, [id, dateCreated, Qid]);
    useEffect(() => {
        const fetchActivities = async (quotationID) => {
            try {
                const response = await fetch(`https://api.cpq.yourcrm.co.za/api/quotations/${quotationID}/care-plan-activities`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });
                if (!response.ok) {
                    throw new Error(`Failed to fetch activities: ${response.statusText}`);
                }
                const data = await response.json();
                console.log(data)
                setActivities(data.activities);
            } catch (error) {
                console.error('An error occurred while fetching the activities:', error);
            }
        };

        if (Quotation) {
            fetchActivities(Quotation.QuotationID);
        }
    }, [Quotation]);

    const fetchCustomerDetails = async (customerId) => {
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/care-recipients/${customerId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // Check if the response is JSON
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                throw new Error("Received non-JSON response");
            }

            const data = await response.json();

            // Assuming the response JSON object has 'Name' and 'Discount' fields
            setCustomerName(data.Name);
            setCustomerDiscount(data.Discount);
        } catch (error) {
            console.error('Error fetching Customer:', error);
        }
    };

    // Fetch customer details on component mount
    useEffect(() => {
        const customerId = id; // Replace with actual customer ID or prop
        fetchCustomerDetails(customerId);
    }, []);


    //
    useEffect(() => {
        const fetchCarePlan = async () => {
            try {
                // const response = await fetch(`https://api.cpq.yourcrm.co.za/api/careplans/${id}/${dateCreated}`);
                const response = await fetch(`https://api.cpq.yourcrm.co.za/api/careplansQuote/${Qid}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    const carePlanID = data.carePlanID;
                    const calculatedTotalsCarePlan = data.lineItems.reduce((totals, item) => {
                        const multiplier = parseFloat(item.Multiplier) || 1;
                        return {
                            SN_HoursDay: totals.SN_HoursDay + (parseFloat(item.SN_HoursDay || 0) * multiplier),
                            SN_HoursNight: totals.SN_HoursNight + (parseFloat(item.SN_HoursNight || 0) * multiplier),
                            ENA_HoursDay: totals.ENA_HoursDay + (parseFloat(item.ENA_HoursDay || 0) * multiplier),
                            ENA_HoursNight: totals.ENA_HoursNight + (parseFloat(item.ENA_HoursNight || 0) * multiplier),
                            CW_HoursDay: totals.CW_HoursDay + (parseFloat(item.CW_HoursDay || 0) * multiplier),
                            CW_HoursNight: totals.CW_HoursNight + (parseFloat(item.CW_HoursNight || 0) * multiplier),
                        };
                    }, {
                        SN_HoursDay: 0,
                        SN_HoursNight: 0,
                        ENA_HoursDay: 0,
                        ENA_HoursNight: 0,
                        CW_HoursDay: 0,
                        CW_HoursNight: 0,
                    });

                    setTotalsCarePlan(calculatedTotalsCarePlan);  // Update totals state

                    const calculatedBenefitTotals = data.lineItems.reduce((benefitsTotals, item) => {

                        return {
                            BenefitBody:
                                (parseFloat(benefitsTotals.BenefitBody || 0) +
                                    (
                                        Number(item.SN_HoursDay) +
                                        Number(item.SN_HoursNight) +
                                        Number(item.ENA_HoursDay) +
                                        Number(item.ENA_HoursNight) +
                                        Number(item.CW_HoursDay) +
                                        Number(item.CW_HoursNight)
                                    ) * ((Number(item.BenefitBody) / 100) || 0)).toFixed(2),

                            BenefitMind:
                                (parseFloat(benefitsTotals.BenefitMind || 0) +
                                    (
                                        Number(item.SN_HoursDay) +
                                        Number(item.SN_HoursNight) +
                                        Number(item.ENA_HoursDay) +
                                        Number(item.ENA_HoursNight) +
                                        Number(item.CW_HoursDay) +
                                        Number(item.CW_HoursNight)
                                    ) * ((Number(item.BenefitMind) / 100) || 0)).toFixed(2),

                            BenefitSocial:
                                (parseFloat(benefitsTotals.BenefitSocial || 0) +
                                    (
                                        Number(item.SN_HoursDay) +
                                        Number(item.SN_HoursNight) +
                                        Number(item.ENA_HoursDay) +
                                        Number(item.ENA_HoursNight) +
                                        Number(item.CW_HoursDay) +
                                        Number(item.CW_HoursNight)
                                    ) * ((Number(item.BenefitSocial) / 100) || 0)).toFixed(2),

                        };
                    }, {
                        BenefitBody: 0,
                        BenefitMind: 0,
                        BenefitSocial: 0,
                    });

                    // Set benefit totals if needed
                    setbenefitsTotals(calculatedBenefitTotals);
                    setCarePlanID(carePlanID);
                } else if (response.status === 404) {
                    // Care plan not found, initiate creation
                    // setCreatingCarePlan(true);
                } else {
                    console.error('Failed to fetch care plan');
                }
            } catch (error) {
                console.error('An error occurred while fetching the care plan:', error);
            }
        };


        fetchCarePlan();

    }, [id, dateCreated]);
    //
    const handleItemChange = (e) => {
        const item = JSON.parse(e.target.value);
        setSelectedItem(item);
    };



    const handleMultiplierChange = (index, value) => {
        // Allow the value to be an empty string
        const newMultiplier = value === '' ? '' : parseFloat(value) || 1; // Default to 1 if value is invalid

        const updatedLineItems = [...lineItems];
        const oldItem = updatedLineItems[index];

        // Capture the previous multiplier to adjust the values accordingly
        const oldMultiplier = parseFloat(oldItem.Multiplier) || 1;

        updatedLineItems[index] = {
            ...oldItem,
            Multiplier: newMultiplier,
            Price: newMultiplier === '' ? oldItem.Price : ((parseFloat(parseCurrency(oldItem.Price)))).toFixed(2),
            SN_HoursDay: newMultiplier === '' ? oldItem.SN_HoursDay : ((parseFloat(oldItem.SN_HoursDay))).toFixed(2),
            SN_HoursNight: newMultiplier === '' ? oldItem.SN_HoursNight : ((parseFloat(oldItem.SN_HoursNight))).toFixed(2),
            ENA_HoursDay: newMultiplier === '' ? oldItem.ENA_HoursDay : ((parseFloat(oldItem.ENA_HoursDay))).toFixed(2),
            ENA_HoursNight: newMultiplier === '' ? oldItem.ENA_HoursNight : ((parseFloat(oldItem.ENA_HoursNight))).toFixed(2),
            CW_HoursDay: newMultiplier === '' ? oldItem.CW_HoursDay : ((parseFloat(oldItem.CW_HoursDay))).toFixed(2),
            CW_HoursNight: newMultiplier === '' ? oldItem.CW_HoursNight : ((parseFloat(oldItem.CW_HoursNight))).toFixed(2),
            Catering: newMultiplier === '' ? oldItem.Catering : ((parseFloat(parseCurrency(oldItem.Catering)))).toFixed(2),
            Cleaning: newMultiplier === '' ? oldItem.Cleaning : ((parseFloat(parseCurrency(oldItem.Cleaning)))).toFixed(2),
            Laundry: newMultiplier === '' ? oldItem.Laundry : ((parseFloat(parseCurrency(oldItem.Laundry)))).toFixed(2),
            Other: newMultiplier === '' ? oldItem.Other : ((parseFloat(parseCurrency(oldItem.Other)))).toFixed(2),
        };

        lineItems[index].Multiplier = newMultiplier;
        const newTotals = calculateTotals(updatedLineItems, hourlyRates);
        setTotals(newTotals);
    };

    // Add this function to handle when the input loses focus
    const handleMultiplierBlur = (index, value) => {
        const updatedLineItems = [...lineItems];
        const oldItem = updatedLineItems[index];

        // If the input is empty, set the multiplier back to 1
        if (value === '') {
            updatedLineItems[index].Multiplier = 1;
        }

        setLineItems(updatedLineItems);
        const newTotals = calculateTotals(updatedLineItems, hourlyRates);
        setTotals(newTotals);
    };


    const handleRemoveLineItem = (index) => {
        const removedItem = lineItems[index];
        const updatedLineItems = lineItems.filter((_, i) => i !== index);

        // Calculate values to subtract based on the multiplier
        const hoursToSubtract = {
            Price: (parseFloat(parseCurrency(removedItem.Price)) * (parseFloat(removedItem.Multiplier) || 1)),
            SN_HoursDay: (parseFloat(removedItem.SN_HoursDay || 0) * (parseFloat(removedItem.Multiplier) || 1)),
            SN_HoursNight: (parseFloat(removedItem.SN_HoursNight || 0) * (parseFloat(removedItem.Multiplier) || 1)),
            ENA_HoursDay: (parseFloat(removedItem.ENA_HoursDay || 0) * (parseFloat(removedItem.Multiplier) || 1)),
            ENA_HoursNight: (parseFloat(removedItem.ENA_HoursNight || 0) * (parseFloat(removedItem.Multiplier) || 1)),
            CW_HoursDay: (parseFloat(removedItem.CW_HoursDay || 0) * (parseFloat(removedItem.Multiplier) || 1)),
            CW_HoursNight: (parseFloat(removedItem.CW_HoursNight || 0) * (parseFloat(removedItem.Multiplier) || 1)),
            Catering: parseFloat(parseCurrency(removedItem.Catering) || 0),
            Cleaning: parseFloat(parseCurrency(removedItem.Cleaning) || 0),
            Laundry: parseFloat(parseCurrency(removedItem.Laundry) || 0),
            Other: parseFloat(parseCurrency(removedItem.Other) || 0),
        };


        const newTotals = {
            Price: totals.Price - hoursToSubtract.Price,
            SN_HoursDay: totals.SN_HoursDay - hoursToSubtract.SN_HoursDay,
            SN_HoursNight: totals.SN_HoursNight - hoursToSubtract.SN_HoursNight,
            ENA_HoursDay: totals.ENA_HoursDay - hoursToSubtract.ENA_HoursDay,
            ENA_HoursNight: totals.ENA_HoursNight - hoursToSubtract.ENA_HoursNight,
            CW_HoursDay: totals.CW_HoursDay - hoursToSubtract.CW_HoursDay,
            CW_HoursNight: totals.CW_HoursNight - hoursToSubtract.CW_HoursNight,
            Cleaning: totals.Cleaning - hoursToSubtract.Cleaning,
            Laundry: totals.Laundry - hoursToSubtract.Laundry,
            Other: totals.Other - hoursToSubtract.Other,
        };

        setTotals(newTotals);

        setLineItems(updatedLineItems);
    };

    const handleAddLineItem = () => {
        if (!selectedItem.PriceListItemID) {
            alert('Please select an Item.');
            return;
        }

        const selectedMultiplier = parseFloat(selectedItem.Multiplier) || 1;
        const newItem = {
            ...selectedItem,
            Price: (parseFloat(parseCurrency(selectedItem.Price) || 0) * selectedMultiplier).toFixed(2),
            SN_HoursDay: (parseFloat(selectedItem.SN_HoursDay || 0) * selectedMultiplier).toFixed(2),
            SN_HoursNight: (parseFloat(selectedItem.SN_HoursNight || 0) * selectedMultiplier).toFixed(2),
            ENA_HoursDay: (parseFloat(selectedItem.ENA_HoursDay || 0) * selectedMultiplier).toFixed(2),
            ENA_HoursNight: (parseFloat(selectedItem.ENA_HoursNight || 0) * selectedMultiplier).toFixed(2),
            CW_HoursDay: (parseFloat(selectedItem.CW_HoursDay || 0) * selectedMultiplier).toFixed(2),
            CW_HoursNight: (parseFloat(selectedItem.CW_HoursNight || 0) * selectedMultiplier).toFixed(2), // Corrected parentheses issue
            Catering: parseFloat(parseCurrency(selectedItem.Catering) || 0).toFixed(2),
            Cleaning: parseFloat(parseCurrency(selectedItem.Cleaning) || 0).toFixed(2),
            Laundry: parseFloat(parseCurrency(selectedItem.Laundry) || 0).toFixed(2),
            Other: parseFloat(parseCurrency(selectedItem.Other) || 0).toFixed(2),
        };

        setLineItems([...lineItems, newItem]);

        const newTotals = {
            Price: totals.Price + parseFloat(newItem.Price),
            SN_HoursDay: totals.SN_HoursDay + parseFloat(newItem.SN_HoursDay),
            SN_HoursNight: totals.SN_HoursNight + parseFloat(newItem.SN_HoursNight),
            ENA_HoursDay: totals.ENA_HoursDay + parseFloat(newItem.ENA_HoursDay),
            ENA_HoursNight: totals.ENA_HoursNight + parseFloat(newItem.ENA_HoursNight),
            CW_HoursDay: totals.CW_HoursDay + parseFloat(newItem.CW_HoursDay),
            CW_HoursNight: totals.CW_HoursNight + parseFloat(newItem.CW_HoursNight),
            Catering: totals.Catering + parseFloat(newItem.Catering),
            Cleaning: totals.Cleaning + parseFloat(newItem.Cleaning),
            Laundry: totals.Laundry + parseFloat(newItem.Laundry),
            Other: totals.Other + parseFloat(newItem.Other),
        };

        setTotals(newTotals);

        const totalSN = (newTotals.SN_HoursDay + newTotals.SN_HoursNight) * hourlyRates.SN;
        const totalENA = (newTotals.ENA_HoursDay + newTotals.ENA_HoursNight) * hourlyRates.ENA;
        const totalCW = (newTotals.CW_HoursDay + newTotals.CW_HoursNight) * hourlyRates.CW;

        const totalLabourCost = totalSN + totalENA + totalCW;

        setSelectedItem({
            PriceListItemID: null,
            ItemName: '',
            Price: '',
            CustomerCareTypeID: null,
            GeneralCategory: '',
            Frequency: '',
            SN_HoursDay: '',
            SN_HoursNight: 0.0,
            ENA_HoursDay: '',
            ENA_HoursNight: 0.0,
            CW_HoursDay: '',
            CW_HoursNight: 0.0,
            Catering: '',
            Cleaning: '',
            Laundry: '',
            Other: '',
            DateFrom: '',
            DateTo: '',
        });
    };


    const handleSubmit = async () => {
        try {

            const response = await fetch('https://api.cpq.yourcrm.co.za/api/EditQuotation', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    CustomerID: id,  // Use extracted CustomerID
                    QuotationID: Quotation.QuotationID,
                    DateCreated: new Date().toISOString().split('T')[0],  // Current date in YYYY-MM-DD format
                    lineItems  // Send the line items along with care plan data
                })
            });

            if (response.ok) {
                setTemp(lineItems)
                setIsSaved(true);
                const result = await response.json();
                alert('Quotation edited successfully');
            } else {
                alert('Failed to submit quotation');
            }

        } catch (error) {
            console.error('An error occurred:', error);
            alert('An error occurred while submitting the Quotation');
        }
    };

    const pieDataBenefits = {
        labels: ['Mind', 'Body', 'Social'],
        datasets: [
            {
                label: 'Services Breakdown',
                data: [
                    benefitsTotals.BenefitBody,
                    benefitsTotals.BenefitMind,
                    benefitsTotals.BenefitSocial,
                ],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.6)',
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 206, 86, 0.6)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',

                ],
                borderWidth: 1,
            },
        ],
    };



    const pieDataTotals = {
        labels: ['Catering', 'Cleaning', 'Labour', 'Laundry', 'Other'],
        datasets: [
            {
                label: 'Services Breakdown',
                data: [
                    totals.Catering,
                    totals.Cleaning,
                    (TotalsCarePlan.SN_HoursDay + TotalsCarePlan.SN_HoursNight, TotalsCarePlan.ENA_HoursDay + TotalsCarePlan.ENA_HoursNight, TotalsCarePlan.CW_HoursDay + TotalsCarePlan.CW_HoursNight),
                    totals.Laundry,
                    totals.Other
                ],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.6)',
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 206, 86, 0.6)',
                    'rgba(75, 192, 192, 0.6)',
                    'rgba(153, 102, 255, 0.6)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)'
                ],
                borderWidth: 1,
            },
        ],
    };
    const snTotalHours = totals.SN_HoursDay + totals.SN_HoursNight;

    const pieDataSN = {
        labels: ['SN Hours Day', 'SN Hours Night'],
        datasets: [
            {
                label: 'Total SN Hours',
                data: [TotalsCarePlan.SN_HoursDay, TotalsCarePlan.SN_HoursNight],
                backgroundColor: ['#36A2EB', '#FF6384'],
                hoverBackgroundColor: ['#36A2EB', '#FF6384'],
                borderWidth: 1,
            },
        ],
    };

    const ENATotalHours = totals.SN_HoursDay + totals.SN_HoursNight;

    const pieDataENA = {
        labels: ['ENA Hours Day', 'ENA Hours Night'],
        datasets: [
            {
                label: 'Total ENA Hours',
                data: [TotalsCarePlan.ENA_HoursDay, TotalsCarePlan.ENA_HoursNight],
                backgroundColor: ['#36A2EB', '#FF6384'],
                hoverBackgroundColor: ['#36A2EB', '#FF6384'],
            },
        ],
    };
    const CWTotalHours = totals.CW_HoursDay + totals.CW_HoursNight;
    const pieDataCW = {
        labels: ['CW Hours Day', 'CW Hours Night'],
        datasets: [
            {
                label: 'Total CW Hours',
                data: [TotalsCarePlan.CW_HoursDay, TotalsCarePlan.CW_HoursNight],
                backgroundColor: ['#36A2EB', '#FF6384'],
                hoverBackgroundColor: ['#36A2EB', '#FF6384'],
            },
        ],
    };


    const total = lineItems.reduce((sum, item) => {
        return sum + (parseCurrency(item.Price) * (item.Multiplier || 1));
    }, 0);

    const [notes, setNotes] = useState('');

    useEffect(() => {
        if (Quotation) {
            setNotes(Quotation.Notes || '');
        }
    }, [Quotation]);

    useEffect(() => {
        const hasChanges =
            JSON.stringify(lineItems) !== JSON.stringify(temp) ||
            CustomerDiscount !== Quotation?.CustomerDiscount ||
            notes !== Quotation?.Notes;

        setIsSaved(!hasChanges);
    }, [lineItems, CustomerDiscount, Quotation, notes]);

    const handleNotesChange = async (newNotes) => {
        setNotes(newNotes);

        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/quotes/updateNotes', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    quoteId: Qid,
                    notes: newNotes
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to update notes');
            }
            console.log('Notes updated successfully');
        } catch (error) {
            console.error('Error updating notes:', error);
        }
    };

    if (noItems) {
        return (
            <div>
                <div className="container mt-4">
                    <h1>No Items Available</h1>
                    <p>There are no items available to add to the quotation at the moment.</p>
                </div>
            </div>
        );
    }

    if (!Quotation) {
        return
        <div>
            Loading...</div>;
    }

    return (
        <div>
            <div id="quotation-content" className="container mt-4">
                {isSticky && <div className={`labour-difference-container ${isSticky ? "sticky-header" : ""}`}>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th></th>
                                <th>SN Hours</th>
                                <th>ENA Hours</th>
                                <th>CW Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Total Labour Hours Difference</td>
                                <td>{((TotalsCarePlan.SN_HoursDay + TotalsCarePlan.SN_HoursNight) - (totals.SN_HoursDay + totals.SN_HoursNight)).toFixed(2)}</td>
                                <td>{((TotalsCarePlan.ENA_HoursDay + TotalsCarePlan.ENA_HoursNight) - (totals.ENA_HoursDay + totals.ENA_HoursNight)).toFixed(2)}</td>
                                <td>{((TotalsCarePlan.CW_HoursDay + TotalsCarePlan.CW_HoursNight) - (totals.CW_HoursDay + totals.CW_HoursNight)).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1 style={{ margin: 0 }}>Quotation Details</h1>
                    <img src={logoUrl} alt="Logo" style={{ height: '70px' }} />
                </div>

                <p>Quotation ID: {Quotation.QuotationID}</p>
                {/* <p>Care Plan ID: {carePlanID}</p> */}
                {/* <div className="text-center">
                    <h3>Summary of Hours</h3>
                </div> */}

                <div className="d-flex justify-content-center mt-4" style={{ gap: '20px' }}>

                    <Table striped bordered hover className="mt-4">

                        <thead>
                            <tr>
                                <th colSpan="4" style={{ textAlign: 'center' }}>
                                    <strong>Summary of Care Plan Hours</strong>
                                </th>

                            </tr>
                            <tr>
                                <th></th>
                                <th>SN Hours</th>
                                <th>ENA Hours</th>
                                <th>CW Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Day</td>
                                <td>{(TotalsCarePlan.SN_HoursDay).toFixed(2)}</td>
                                <td>{(TotalsCarePlan.ENA_HoursDay).toFixed(2)}</td>
                                <td>{(TotalsCarePlan.CW_HoursDay).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Night</td>
                                <td>{(TotalsCarePlan.SN_HoursNight).toFixed(2)}</td>
                                <td>{(TotalsCarePlan.ENA_HoursNight).toFixed(2)}</td>
                                <td>{(TotalsCarePlan.CW_HoursNight).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>{(TotalsCarePlan.SN_HoursDay + TotalsCarePlan.SN_HoursNight).toFixed(2)}</td>
                                <td>{(TotalsCarePlan.ENA_HoursDay + TotalsCarePlan.ENA_HoursNight).toFixed(2)}</td>
                                <td>{(TotalsCarePlan.CW_HoursDay + TotalsCarePlan.CW_HoursNight).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <th colSpan="4" style={{ textAlign: 'center' }}>
                                    <strong>Summary of Quotation Hours </strong>
                                </th>
                            </tr>

                            <tr>
                                <th></th>
                                <th>SN Hours</th>
                                <th>ENA Hours</th>
                                <th>CW Hours</th>
                            </tr>


                            <tr>
                                <td>Day</td>
                                <td>{(totals.SN_HoursDay).toFixed(2)}</td>
                                <td>{(totals.ENA_HoursDay).toFixed(2)}</td>
                                <td>{(totals.CW_HoursDay).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Night</td>
                                <td>{(totals.SN_HoursNight).toFixed(2)}</td>
                                <td>{(totals.ENA_HoursNight).toFixed(2)}</td>
                                <td>{(totals.CW_HoursNight).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>{(totals.SN_HoursDay + totals.SN_HoursNight).toFixed(2)}</td>
                                <td>{(totals.ENA_HoursDay + totals.ENA_HoursNight).toFixed(2)}</td>
                                <td>{(totals.CW_HoursDay + totals.CW_HoursNight).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Total Labour (R)</td>
                                <td>{((totals.SN_HoursDay + totals.SN_HoursNight) * hourlyRates.SN).toFixed(2)}</td>
                                <td>{((totals.ENA_HoursDay + totals.ENA_HoursNight) * hourlyRates.ENA).toFixed(2)}</td>
                                <td>{((totals.CW_HoursDay + totals.CW_HoursNight) * hourlyRates.CW).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <th colSpan="4" style={{ textAlign: 'center' }}>
                                    <strong>Care Plan Labour Difference (hours) </strong>
                                </th>
                            </tr>
                            <tr>
                                <th></th>
                                <th>SN Hours</th>
                                <th>ENA Hours</th>
                                <th>CW Hours</th>
                            </tr>
                            <tr>
                                <td>Total Labour Hours Difference</td>
                                <td>{((TotalsCarePlan.SN_HoursDay + TotalsCarePlan.SN_HoursNight) - (totals.SN_HoursDay + totals.SN_HoursNight)).toFixed(2)}</td>
                                <td>{((TotalsCarePlan.ENA_HoursDay + TotalsCarePlan.ENA_HoursNight) - (totals.ENA_HoursDay + totals.ENA_HoursNight)).toFixed(2)}</td>
                                <td>{((TotalsCarePlan.CW_HoursDay + TotalsCarePlan.CW_HoursNight) - (totals.CW_HoursDay + totals.CW_HoursNight)).toFixed(2)}</td>
                            </tr>


                        </tbody>
                    </Table>
                </div>

                <div className="d-flex justify-content-center mt-4" style={{ gap: '20px' }}>

                    <Table striped bordered hover className="mt-4">
                        <thead>
                            <tr>
                                <th colSpan="2" style={{ textAlign: 'center' }}>
                                    <strong>Summary of Benefits</strong>
                                </th>

                            </tr>
                            <tr>
                                <th>Benefit Type</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Body</td>
                                <td>{benefitsTotals.BenefitBody}</td>
                            </tr>
                            <tr>
                                <td>Mind</td>
                                <td>{benefitsTotals.BenefitMind}</td>
                            </tr>
                            <tr>
                                <td>Social</td>
                                <td>{benefitsTotals.BenefitSocial}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <div className="text-center">
                    <h3>Quotation</h3>
                </div>
                <Form id="form-to-hide">
                    <Form.Group controlId="activitySelect">
                        <Form.Label>Select Item</Form.Label>
                        <Form.Control
                            as="select"
                            name="ItemID"
                            value={JSON.stringify(selectedItem)} // Display the selected activity name
                            onChange={handleItemChange}
                            style={{ width: 'auto' }}
                        >
                            <option value="">Select an Item</option>
                            {/* {items.map(item => (
                                <option key={item.PriceListItemID} value={JSON.stringify(item)}>
                                    {item.ItemName}
                                </option>
                            ))} */}
                            {items
                                .filter(activity => !filteredItems.some(item => item.PriceListItemID === activity.PriceListItemID))
                                .map(lineItem => (
                                    <option key={lineItem.PriceListItemID} value={JSON.stringify(lineItem)}>
                                        {lineItem.ItemName}
                                    </option>
                                ))}
                        </Form.Control>
                    </Form.Group>
                    {/* Other form fields go here */}
                    <Button disabled={!selectedItem.PriceListItemID} className='mt-2 mb-4' onClick={handleAddLineItem}>Add Line Item</Button>
                </Form>
                {/* 
                <div style={{ overflowX: 'auto' }}> */}
                <Form.Control
                    type="text"
                    placeholder="Search by Item Name or Description..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="mb-0"
                />
                <div className='table-controls'>
                    <Button
                        variant="link"
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        {collapsed ? <FaAngleRight /> : <FaAngleLeft />}
                        {collapsed ? "Expand Columns" : "Collapse Columns"}
                    </Button>
                </div>
                <div className='table-wrapper mt- mb-4'>
                    <Table striped bordered hover className="mb-0">
                        <thead>
                            <tr>
                                <th rowSpan="2">Actions</th>
                                <th rowSpan="2" onClick={() => handleSort('ItemName')}>Item {getSortIndicator('ItemName')}</th>
                                <th rowSpan="2" onClick={() => handleSort('Description')}>Description {getSortIndicator('Description')}</th>
                                <th rowSpan="2" onClick={() => handleSort('Multiplier', true)}>Multiplier {getSortIndicator('Multiplier')}</th>
                                <th rowSpan="2" onClick={() => handleSort('Price', true)}>Price(R) {getSortIndicator('Price')}</th>
                                <th rowSpan="2" onClick={() => handleSort('Frequency')}>Frequency {getSortIndicator('Frequency')}</th>
                                <th colSpan="2">SN Hours</th>
                                <th colSpan="2">ENA Hours</th>
                                <th colSpan="2">CW Hours</th>
                                <th colSpan="4" style={{ display: collapsed ? 'none' : 'table-cell' }}>Additional Costs</th>
                            </tr>
                            <tr>
                                <th onClick={() => handleSort('SN_HoursDay', true)}>Day {getSortIndicator('SN_HoursDay')}</th>
                                <th onClick={() => handleSort('SN_HoursNight', true)}>Night {getSortIndicator('SN_HoursNight')}</th>
                                <th onClick={() => handleSort('ENA_HoursDay', true)}>Day {getSortIndicator('ENA_HoursDay')}</th>
                                <th onClick={() => handleSort('ENA_HoursNight', true)}>Night {getSortIndicator('ENA_HoursNight')}</th>
                                <th onClick={() => handleSort('CW_HoursDay', true)}>Day {getSortIndicator('CW_HoursDay')}</th>
                                <th onClick={() => handleSort('CW_HoursNight', true)}>Night {getSortIndicator('CW_HoursNight')}</th>
                                <th style={{ display: collapsed ? 'none' : 'table-cell' }} onClick={() => handleSort('Catering', true)}>Catering(R) {getSortIndicator('Catering')}</th>
                                <th style={{ display: collapsed ? 'none' : 'table-cell' }} onClick={() => handleSort('Cleaning', true)}>Cleaning(R) {getSortIndicator('Cleaning')}</th>
                                <th style={{ display: collapsed ? 'none' : 'table-cell' }} onClick={() => handleSort('Laundry', true)}>Laundry(R) {getSortIndicator('Laundry')}</th>
                                <th style={{ display: collapsed ? 'none' : 'table-cell' }} onClick={() => handleSort('Other', true)}>Other(R) {getSortIndicator('Other')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredItems.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <Button variant="link" onClick={() => {
                                            if (window.confirm("Are you sure you want to remove this item?")) {
                                                handleRemoveLineItem(index);
                                            }
                                        }}>

                                            <FaTrash style={{ color: '#dc3545', fontSize: '1.2rem' }} />
                                        </Button>
                                    </td>
                                    <td>{item.ItemName}</td>
                                    <td>{item.Description}</td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={item.Multiplier !== null && item.Multiplier !== undefined ? item.Multiplier : '1'}
                                            onChange={(e) => handleMultiplierChange(index, e.target.value)}
                                            onBlur={(e) => handleMultiplierBlur(index, e.target.value)}
                                        />
                                    </td>
                                    <td>{parseCurrency(item.Price) * (item.Multiplier || 1)}</td>
                                    <td>{item.Frequency}</td>
                                    <td>{(item.SN_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.SN_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.ENA_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.ENA_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.CW_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.CW_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                    <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{(parseCurrency(item.Catering) || 0) * (item.Multiplier || 1)}</td>
                                    <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{(parseCurrency(item.Cleaning) || 0) * (item.Multiplier || 1)}</td>
                                    <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{(parseCurrency(item.Laundry) || 0) * (item.Multiplier || 1)}</td>
                                    <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{(parseCurrency(item.Other) || 0) * (item.Multiplier || 1)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="3"><strong>Total(R)</strong></td>
                                <td>{total.toFixed(2)}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{totals.Catering ? totals.Catering.toFixed(2) : '0.00'}</td>
                                <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{totals.Cleaning ? totals.Cleaning.toFixed(2) : '0.00'}</td>
                                <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{totals.Laundry ? totals.Laundry.toFixed(2) : '0.00'}</td>
                                <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{totals.Other ? totals.Other.toFixed(2) : '0.00'}</td>
                            </tr>
                        </tfoot>
                    </Table>
                </div>
                {/* </div> */}

                <h3>Customer: {CustomerName}</h3>
                <h3>Report Date: {formattedDate} </h3>
                <h3>Total Monthly Fee: R{total.toFixed(2)}</h3>
                <h3>Discount: {CustomerDiscount} %</h3>
                <h3>Final Quoted Price: R {(total - ((total * CustomerDiscount) / 100)).toFixed(2)} </h3>

                <div className="d-flex justify-content-center mt-4" style={{ gap: '20px' }}>
                    {/* Care Plan Activities Table */}
                    <Table striped bordered hover className="mr-4">
                        <thead>
                            <tr>
                                <th>Care Plan Activities</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activities.length > 0 ? (
                                activities.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td>No Care Plan activities found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    {/* Quoted Items Table */}
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Quoted Services</th>
                                <th>Fee</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lineItems.length > 0 ? (
                                lineItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.ItemName}</td>
                                        <td>{parseCurrency(item.Price)}</td>
                                    </tr>

                                ))
                            ) : (
                                <tr>
                                    <td>No Services Quoted</td>
                                    <td></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                <div id="summary-details">
                    <h1>Quotation Summary Details</h1>

                    <div className="chart-container">
                        <div className="chart-item">
                            <h2>Services Breakdown</h2>
                            <Pie data={pieDataTotals} />
                        </div>

                        <div className="chart-item">
                            <h2>Total Senior Nurse Hours per Day</h2>
                            <Pie data={pieDataSN} />
                        </div>
                    </div>

                    <div className="chart-container-two">
                        <div className="chart-item">
                            <h2>Total Enrolled Nurse Hours per Day</h2>
                            <Pie data={pieDataENA} />
                        </div>

                        <div className="chart-item">
                            <h2>Total Care Worker Hours per Day</h2>
                            <Pie data={pieDataCW} />
                        </div>
                    </div>
                    <div className="chart-container-three">
                        <div className="chart-item">
                            <h2>Benefits Total</h2>
                            <Pie data={pieDataBenefits} />
                        </div>
                    </div>


                    <style>
                        {`
        #summary-details {
            padding: 20px;
        }

        .chart-container, .chart-container-two, .chart-container-three {
            display: flex;
            justify-content: center; /* Center charts horizontally */
            gap: 2rem; /* Space between charts */
            margin-bottom: 2rem; /* Space between rows */
        }

        .chart-item {
            text-align: center;
            width: 400px; /* Fixed width for each chart */
        }

        .chart-item .chart {
            width: 100%;
            height: 400px; /* Fixed height for charts */
        }

        h1 {
            margin-bottom: 2rem;
        }

        h2 {
            margin-bottom: 1rem;
        }
    `}
                    </style>
                </div>

                <div className="quotation-notes-section">
                    <h5>Additional Notes</h5>
                    <Form.Group controlId="quotationNotes">
                        <ReactQuill
                            value={notes}
                            onChange={handleNotesChange}
                            placeholder="Enter any additional notes here..."
                            className="mb-4"
                        />
                    </Form.Group>

                    <div className="signature-blocks">
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group controlId="clientSignatureName">
                                    <Form.Label>Client Name</Form.Label>
                                    <Form.Control type="text" placeholder="" className="mb-2" />
                                </Form.Group>
                                <Form.Group controlId="clientSignatureDate">
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control type="text" className="mb-4" />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group controlId="companySignatureName">
                                    <Form.Label>Company Representative Name</Form.Label>
                                    <Form.Control type="text" placeholder="" className="mb-2" />
                                </Form.Group>
                                <Form.Group controlId="companySignatureDate">
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control type="text" className="mb-4" />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="buttons">
                    <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end', gap: '8px', }} >

                        {isSaved ? <Button className="mt-4" onClick={handleCreateQuotepdf}>Download as PDF</Button> : <Button className="mt-4" onClick={handleSubmit}>Save Quotation</Button>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuotationDetail;
